import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import {
  RetrieveNewUser,
  getRoles,
  inviteMember,
} from "../../../services/settings";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContextProvider";
import Toggle from "../../../components/Toggle";
import BusinessName from "../../../components/BusinessName";

const SendInvite = ({ handleInvite, handleCancel, handlePermissionInvite }) => {
  const [roles, setRoles] = useState([]);
  const [mail, setMail] = useState("");
  const [roleId, setRoleId] = useState("");
  const { user, globalProfile } = useAuth();
  const permissions = user.permissionList;

  const handleRoleSelect = (e) => {
    setRoleId(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await inviteMember({
        emailAddress: mail,
        roleId: roleId,
      });
      toast.success(res.message);
      handleInvite();
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const fetchRoles = async () => {
    try {
      const res = await getRoles();
      setRoles(res.data);
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    // console.log(roles);
    fetchRoles();
  }, [globalProfile]);

  return (
    <div className="overflow-hidden">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between">
        <h1 className="text-2xl font-bold text-navy-blue">
          Settings - Permission
        </h1>
        <Toggle />
      </div>

      {/* <section className="flex md:justify-end text-xl font-bold pt-4 mb-4 pr-4">
        <span className="ml-2">
          <BusinessName />
        </span>
      </section> */}

      <div className=" max-w-72  md:max-w-full bg-white mt-8 rounded-[10px] md:p-[3rem]">
        <div className="border border-gray-200 rounded-t-[10px] p-[1rem] pl-7 flex justify-between items-center">
          <p className="text-primary text-xl font-semibold">
            Add user permission
          </p>
          <span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.5 6.75L9 11.25L13.5 6.75"
                stroke="#464255"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>

        <article className="flex flex-col lg:flex-row mt-2 px-8 py-4">
          <section className="flex-[0.6]">
            <div className="w-[420px] flex flex-col gap-4">
              <div className="text-lg md:text-xl">
                Send an invite to new members
              </div>
              <div className="text-sm max-w-60 md:max-w-full">
                Enter the email address of the user you want to invite, and
                choose the role they should have.
              </div>
              <form onSubmit={handleSubmit}>
                <div className="flex flex-col">
                  <label
                    htmlFor="email"
                    className="text-gray-600 font-semibold"
                  >
                    Email address
                  </label>
                  <input
                    onChange={(e) => setMail(e.target.value)}
                    type="text"
                    name="email"
                    placeholder="Enter email address"
                    className="bg-form-background w-60 md:w-[460px] h-[50px] mt-2 px-4 rounded-md text-gray-600 focus:outline-none"
                  />
                </div>

                <div className="flex flex-col relative">
                  <label htmlFor="role" className="text-gray-600 font-semibold">
                    Role
                  </label>
                  <select
                    className="bg-form-background  w-60 md:w-[460px] h-[50px] mt-2 px-4 rounded-md text-gray-600 focus:outline-none"
                    onChange={handleRoleSelect}
                  >
                    <option value="">Select Role</option>
                    {roles.map((role) => (
                      <option key={role.id} value={role.id}>
                        {role.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className=" flex flex-col md:flex-row mt-4 gap-4 justify-center">
                  <button
                    onClick={handleCancel}
                    className="w-[142px] text-primary border border-primary p-2 rounded-md"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="md:w-[272px] w-[142px] mb-4 md:mb-0 bg-primary text-white p-2 rounded-md "
                  >
                    Continue to permission
                  </button>
                </div>
              </form>
            </div>
          </section>

          <section
            className={`flex-[0.4] ${
              permissions.includes("List Roles") ? "block" : "hidden"
            }`}
          >
            <article className="border py-2 px-4 md:w-[350px]">
              <div className="border-b-2 pb-4">Role descriptions</div>
              {roles.map((role) => (
                <ul className="list-disc flex flex-col gap-4 px-8 py-4 ">
                  <li key={role.id}>
                    <div className="flex flex-col border-b pb-6">
                      <span>{role.name} -</span>
                      <span
                        class="text-blue-400 font-sm underline cursor-pointer"
                        onClick={() => handlePermissionInvite(role.id)}
                      >
                        View permissions
                      </span>
                    </div>
                  </li>
                </ul>
              ))}
            </article>
          </section>
        </article>
      </div>
    </div>
  );
};

export default SendInvite;
